import config from 'Cloud/config';
import { IS_B2B_BIZ_USER, IS_PHONE_BROWSER, IS_PWA, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { litresDwhParams } from 'reactApp/appHelpers/featuresHelpers/features/litres';
import { marchPromo2026 } from 'reactApp/appHelpers/featuresHelpers/features/marchPromo2026';
import { summerPromo2026, summerPromo2026Anonym } from 'reactApp/appHelpers/featuresHelpers/features/summerPromo2026';
import { getUtmObject, isDesktopR7App } from 'reactApp/appHelpers/settingsHelpers';
import {
    autumnPromoDwh,
    blackFriday2024Dwh,
    blackFriday2025Dwh,
    cyberMonday2025Dwh,
    getMarchPromo2026Dwh,
    getSummerPromo2026Dwh,
    logInAccountModalDwh,
    mayPromo2025Dwh,
} from 'reactApp/constants/dwh';
import { checkPromoForceQuery } from 'reactApp/hooks/useMarchPromo2026';
import { getCheckABStatus } from 'reactApp/modules/checkAB/checkAB.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { ReceivedGiftsFetch } from 'reactApp/modules/giftReceived/giftReceived.constants';
import { GiftReceivedSelectors } from 'reactApp/modules/giftReceived/receivedGiftBillingData.adapter';
import { getLoadingState } from 'reactApp/modules/loading/loading.selectors';
import { PromoTariffsSelectors } from 'reactApp/modules/promoTariffs/promoTariffsBillingData.adapter';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { getWebPushPermission } from 'reactApp/modules/webPush/webPush.utils';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

export interface IPaymentGa extends Record<string, any> {
    action?: EPaymentGa | string;
    label?: string;
    /**
     * @deprecated Умеем по сегментам омикрона определять группу
     */
    group?: string;
    eventCategory?: string;
    dwh_enabled?: boolean;
    dwh_enabled_fields?: string[][];
}

export enum EPaymentGa {
    space = 'standart-more-quota',
    spaceDiscount = 'discount-more-quota',
    spaceAction = 'action-quota',
    promocodesSection = 'section-promocodes',
    overquotaBanner = 'part-data-delete',
    overquotaMobile = 'overquota-mobile',
    expiredSubsMobile = 'expired-subs-mobile',
    quotaBanner = 'few-quota',
    offerBanner = 'present-gb',
    bigFileModal = 'heavy-file',
    filesHistory = 'history-files',
    filesHistoryPaid = 'history-files-paid',
    fastCheckout = 'fastcheckout',
    tariffsModal = 'popup-cloud-tariff',
    subscriptions = 'screen-cloud-tariff',
    trialBuyModal = 'popup-discount',
    payment = 'popup-payment',
    trialWindow = 'trial-window',
    saveInCloud = 'save-in-cloud',
    openPublic = 'open-public',
    popup = 'pop-up',
    touchSubs = 'touch-subs',
    openContent = 'open-content',
    close = 'close',
    unionQuota = 'union-quota',
    attachesTrial = 'attachesTrial',
    familySubscription = 'family-sub',
    paymentWindow = 'dop-payment',
    seoComplaint = 'seo-complaint',
    webPush = 'web-push',
}

export enum ECategoryGa {
    payment = 'payment',
    entered = 'entered',
    basket = 'basket',
    favorites = 'favorites',
    new_year = 'new-year',
    nine_may = '9-may',
    favoritesSearch = 'favorites-search',
    folder = 'folder',
    public = 'public',
    public_touch = 'public-touch',
    publicSearch = 'public-search',
    publicActionToInstall = 'public-action-to-install',
    publicAuthBanner = 'public-auth-banner',
    publicRegBanner = 'public-reg-banner',
    download = 'download',
    downloadSearch = 'download-search',
    upload = 'upload',
    uploadFileToCloud = 'upload-file-to-cloud',
    created = 'created',
    sharedFolder = 'shared-folder',
    banner = 'banner',
    storiesAb = 'stories_ab',
    onboarding = 'onboarding',
    toolbar = 'toolbar',
    toolbar_search = 'toolbar-search',
    disable_ads_button = 'disable-ads-button',
    splashscreen_alert = 'splashscreen_alert',
    album = 'album',
    unionQuota = 'union_quota',
    viewer = 'viewer',
    viewer_search = 'viewer-search',
    story = 'story',
    '2gb' = '2gb',
    search = 'search',
    search_history = 'search_history',
    securityShield = 'security-shield',
    security = 'security',
    search_results = 'search-results',
    pdfEditor = 'pdf-editor',
    pdfEditorSearch = 'pdf-editor-search',
    bell = 'bell',
    promoDiskO = 'promo-disko',
    kaspersky = 'kaspersky',
    choose = 'choose',
    quotaTariffs = 'union-quota',
    landingBirthday = 'landing-birthday',
    promocodes = 'landing-promocodes',
    docs = 'docs',
    addPhone = 'adding_phone_number',
    archiveSearch = 'archive-search',
    photoEditor = 'photo-editor',
    context_search = 'context-search',
    snack = 'snack',
    snackActionBlock = 'snack_actionblock',
    gpt = 'gpt',
    fakedoorSafe = 'fakedoor-safe',
    docsEditor = 'docs_editor',
    errorShow = 'error-show',
    editor = 'editor',
    balloon = 'balloon',
    informationAlert = 'information-alert',
    modal = 'modal',
    modalActionBlock = 'modal_actionblock',
    modalReferral = 'modal-referral',
    modalReferralThanks = 'modal-referral-thanks',
    createPortfolio = 'create-portfolio',
    leftnav = 'leftnav',
    modalFileRecovery = 'modal-file-recovery',
    modalFileRecoveryThanks = 'modal-file-recovery-thanks',
    informer = 'informer',
    tooltip = 'tooltip',
    popup = 'pop-up',
    fakedoorPostpaid = 'fakedoor_postpaid',
    fakedoorPostpaidThanks = 'fakedoor_postpaid_thanks',
    menu = 'menu',
    button = 'button',
    counter = 'counter',
    features = 'features',
    redirectPromoElement = 'redirect-promo-element',
    referalFriendsBonus = 'referal_friends_bonus',
    referalBanner = 'referal_banner',
    referalModal = 'referal_modal',
    referalInfo = 'referal_info',
    vigbo = 'vigbo',
    vigboEmptyFeatures = 'promo-empty-state-vigbo',

    sidebar_promo_button_family_section = 'promo_button_family_section',
    promo_button_family_albums = 'promo_button_family_albums',
    summerCollage = 'summer_collage',
    valentinesDay = 'valentines_day',
    kotopadGame = 'kotopad_game',
    photoSelfie = 'photo_selfie',
    mainFunction = 'main_function',

    duplicates = 'duplicates',
    vpn = 'vpn',
    alertVpn = 'alert_vpn',

    cloudFilesMigration = 'cloud_files_migration',
    telegram = 'telegram',
    aiPhotoGeneration = 'ai-photo-generation',
}

const isPhone = Boolean(config.get('PHONE_BROWSER'));
const userSpace = config.get('user')?.cloud?.space;

const isValue = (val) => {
    return val !== undefined && val !== null;
};

export const sendPaymentGa = ({
    action,
    label,
    group = 'None',
    eventCategory = ECategoryGa.payment,
    dwh_enabled = false,
    dwh_enabled_fields = undefined,
    ...restData
}: IPaymentGa): void => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);

    const isLoadingTrial = PromoTariffsSelectors.getLoadingState(state);
    const trial = PromoTariffsSelectors.sortDiscountPromoBySpace(state)?.length;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isLoadingDiscount = getLoadingState(state, [ReceivedGiftsFetch.NAME]);
    const discount = GiftReceivedSelectors.getDiscountGiftList(state)?.length;

    const isOverQuotaCloud = UserSelectors.isOverQuotaUser(state);
    const isAnonymous = UserSelectors.isAnonymous(state);
    const isOverquotaFromProfileApi = UserQuotaSelectors.isOverquotaBySpaceAndApi(state);
    const isOverQuotaMailAndCloud = UserQuotaSelectors.isOverquota(state);
    const isOverQuotaUser = isOverQuotaCloud || isOverquotaFromProfileApi || isOverQuotaMailAndCloud;
    const isPaidUser = UserSelectors.isPaidUser(state);
    const isBizUser = UserSelectors.isBizUser(state);
    const isCorpUser = UserSelectors.isCorpUser(state);

    const isCheckAB = getCheckABStatus(state);

    const marchPromo2026Enabled = (marchPromo2026 || checkPromoForceQuery()) && !isOverQuotaUser && !isPaidUser && isBizUser;
    const summerPromo2026FeatureEnabled = (isAnonymous && summerPromo2026Anonym) || (!isAnonymous && summerPromo2026);
    const summerPromo2026Enabled = summerPromo2026FeatureEnabled && !isPaidUser && !isOverQuotaUser && !isBizUser;

    const { place, source, ...rest } = Object.entries(restData).reduce(
        (acc, [key, value]) => (isValue(value) ? { ...acc, [key]: value } : acc),
        {} as typeof restData
    );

    const platform = isPhone ? 'touch' : 'web';

    const utms = getUtmObject();

    const dwhData = {
        size_quota: userSpace?.bytes_total,
        free_quota: userSpace?.bytes_total - userSpace?.bytes_used,
        free_user: !isPaidUser,
        paid_user: isPaidUser,
        corp_user: isCorpUser,
        campaign: true,
        promocode_trial: isLoadingTrial ? 'None' : !!trial,
        promocode_discount: isLoadingDiscount ? 'None' : !!discount,
        group,
        place: place ? `${place}-${platform}` : platform,
        source: source && isPhone ? `touch-${source}` : source || platform,
        isPhone,
        platform: IS_PHONE_BROWSER ? String(EnvironmentSelectors.getMobileType()).toLowerCase() : 'web',
        webview: IS_WEBVIEW,
        iz_biz: IS_B2B_BIZ_USER,
        desktop_r7: isDesktopR7App(),
        is_vpn: isCheckAB ? isCheckAB : false,
        is_pwa: IS_PWA,
        web_push_permission: getWebPushPermission(),
        ...autumnPromoDwh,
        ...blackFriday2024Dwh,
        ...cyberMonday2025Dwh,
        ...(!isOverQuotaUser && { ...mayPromo2025Dwh }),
        ...(!isOverQuotaUser && { ...blackFriday2025Dwh }),
        ...getMarchPromo2026Dwh(marchPromo2026Enabled),
        ...getSummerPromo2026Dwh(summerPromo2026Enabled),
        ...(isPhone && isAnonymous && storage === EStorageType.public && { ...logInAccountModalDwh }),
        ...litresDwhParams,
        ...utms,
        ...rest,
    };

    sendDwh({ eventCategory, action, label, dwhData, dwh_enabled, dwh_enabled_fields });
};
